import React from 'react';
import { IconSuccess, dlsColorWarning } from '@americanexpress/dls-react';
import RegistrationResultPage from './RegistrationResultPage';

/**
 * Partial-success page shown when the enterprise sign-up completed but the
 * follow-up enrollment to SFT product could not be finished. The user can
 * log in with their newly created credentials to finish setting up access.
 */
const RegistrationAlmostTherePage = () => (
  <RegistrationResultPage
    status="partial"
    icon={<IconSuccess size="lg" theme={dlsColorWarning} />}
    heading="You’re Almost There"
    details="Your registration was successful, but we couldn’t complete your FileXpress enrollment. Please log in using your newly created credentials to finish setting up your access."
  />
);

export default RegistrationAlmostTherePage;
